export default __webpack_public_path__ + "static/media/Twitter.abc12a32.png";